import { schema } from "normalizr";

export const content = new schema.Entity("contents") 
export const correctionCriteria = new schema.Entity("correction_criterias");
export const exam = new schema.Entity("exams");
export const examApplication = new schema.Entity("exam_applications");
export const examQuestion = new schema.Entity("exam_questions");
export const examinationBoard = new schema.Entity("examination_boards");
export const image = new schema.Entity("images");
export const institution = new schema.Entity("institutions");
export const knowledgeAssociation = new schema.Entity("knowledge_associations");
export const listItem = new schema.Entity("list_items");
export const material = new schema.Entity("materials");
export const questionApplication = new schema.Entity("question_applications")
export const reply = new schema.Entity("replies");
export const text = new schema.Entity("texts");
export const user = new schema.Entity("users");
export const video = new schema.Entity("videos");

export const annotation = new schema.Entity("annotations", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let contentsByAnnotationId;
    if (value.contentsByAnnotationId) {
      contentsByAnnotationId = value.contentsByAnnotationId.nodes;
    }
    return {
      ...value,
      contentsByAnnotationId
    }
  }
});

export const article = new schema.Entity("articles", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let contentsByArticleId;
    if (value.contentsByArticleId) {
      contentsByArticleId = value.contentsByArticleId.nodes;
    }
    return {
      ...value,
      contentsByArticleId
    };
  }
});

export const assertion = new schema.Entity("assertions", {}, {
  processStrategy: (value: any, parent: any, key: any) => {
    let contentsByAssertionId;
    if (value.contentsByAssertionId) {
      contentsByAssertionId = value.contentsByAssertionId.nodes;
    }
    return {
      ...value,
      contentsByAssertionId
    }
  }
});

export const assignment = new schema.Entity("assignments", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let repliesByAssignmentId, numberOfReplies;
    if (value.repliesByAssignmentId) {
      repliesByAssignmentId = value.repliesByAssignmentId.nodes;
      numberOfReplies = value.repliesByAssignmentId.totalCount;
    }
    return {
      ...value,
      repliesByAssignmentId,
      numberOfReplies
    }
  }
});

export const board = new schema.Entity("boards", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let materialsByBoardId, boardSectionsByBoardId;
    if (value.materialsByBoardId) {
      materialsByBoardId = value.materialsByBoardId.nodes;
    }
    if (value.boardSectionsByBoardId) {
      boardSectionsByBoardId = value.boardSectionsByBoardId.nodes;
    }
    return {
      ...value,
      materialsByBoardId,
      boardSectionsByBoardId
    };
  }
});

export const boardSection = new schema.Entity("board_sections", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let materialsByBoardSectionsId;
    if (value.materialsByBoardSectionsId) {
      materialsByBoardSectionsId = value.materialsByBoardSectionsId.nodes;
    }
    return {
      ...value,
      materialsByBoardSectionsId
    };
  }
});

export const correction = new schema.Entity("corrections", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let correctionScoresByCorrectionId;
    if (value.correctionScoresByCorrectionId) {
      correctionScoresByCorrectionId =
        value.correctionScoresByCorrectionId.nodes;
    }
    return {
      ...value,
      correctionScoresByCorrectionId
    };
  }
});

export const correctionScore = new schema.Entity("correction_scores", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let annotationsByCorrectionScoreId;
    if (value.annotationsByCorrectionScoreId) {
      annotationsByCorrectionScoreId =
        value.annotationsByCorrectionScoreId.nodes;
    }
    return {
      ...value,
      annotationsByCorrectionScoreId
    };
  }
});

export const essayReply = new schema.Entity("essay_replies", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let contentsByEssayReplyId, correctionsByEssayReplyId;
    if (value.contentsByEssayReplyId) {
      contentsByEssayReplyId = value.contentsByEssayReplyId.nodes;
    }
    if (value.correctionsByEssayReplyId) {
      correctionsByEssayReplyId = value.correctionsByEssayReplyId.nodes;
    }
    return {
      ...value,
      contentsByEssayReplyId,
      correctionsByEssayReplyId
    };
  }
});

export const examMode = new schema.Entity("exam_modes", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let questionsByExamModeId;
    if (value.questionsByExamModeId) {
      questionsByExamModeId = value.questionsByExamModeId.nodes;
    }
    return {
      ...value,
      questionsByExamModeId
    };
  }
});

export const examGroup = new schema.Entity("exam_groups", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let materialsByExamGroupId, examGroupsExamsByExamGroupId, examCount;
    if (value.materialsByExamGroupId) {
      materialsByExamGroupId = value.materialsByExamGroupId.nodes;
    }
    if (value.examGroupsExamsByExamGroupId) {
      examGroupsExamsByExamGroupId = value.examGroupsExamsByExamGroupId.nodes;
      examCount = value.examGroupsExamsByExamGroupId.totalCount;
    }
    return {
      ...value,
      materialsByExamGroupId,
      examGroupsExamsByExamGroupId,
      examCount
    }
  }
});

export const examGroupsExams = new schema.Entity("exam_groups_exams", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let examGroupByExamGroupId;
    if (value.examGroupByExamGroupId) {
      examGroupByExamGroupId = value.examGroupByExamGroupId.nodes;
    }
    return {
      ...value,
      examGroupByExamGroupId
    };
  }
});

export const knowledge = new schema.Entity("knowledges", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let ltreeKnowledgesByParentId,
        ltreeKnowledgeAssociationsByLtreeKnowledgeId,
        numberOfAssociations;
    if (value.ltreeKnowledgesByParentId) {
      ltreeKnowledgesByParentId = value.ltreeKnowledgeByParentId.nodes;
    } 
    if (value.ltreeKnowledgeAssociationsByLtreeKnowledgeId) {
      ltreeKnowledgeAssociationsByLtreeKnowledgeId = value.ltreeKnowledgeAssociationsByLtreeKnowledgeId.nodes;
      numberOfAssociations = value.ltreeKnowledgeAssociationsByLtreeKnowledgeId.totalCount;
    }
    return {
      ...value,
      ltreeKnowledgesByParentId,
      ltreeKnowledgeAssociationsByLtreeKnowledgeId,
      numberOfAssociations
    }
  }
});

export const list = new schema.Entity("lists", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let listItemsByListId;
    if (value.listItemsByListId) {
      listItemsByListId = value.listItemsByListId.nodes;
    }
    return {
      ...value,
      listItemsByListId
    };
  }
});

export const question = new schema.Entity("questions", {}, {
  processStrategy: (value: any, parent: any, key: string) => {
    let contentsByQuestionId,
      solutionsByQuestionId,
      materialsByQuestionId,
      essayRepliesByQuestionId,
      examQuestionsByQuestionId,
      questionApplicationsByQuestionId,
      assertionsByQuestionId;

    if (value.contentsByQuestionId) {
      contentsByQuestionId = value.contentsByQuestionId.nodes;
    }
    if (value.solutionsByQuestionId) {
      solutionsByQuestionId = value.solutionsByQuestionId.nodes;
    }
    if (value.materialsByQuestionId) {
      materialsByQuestionId = value.materialsByQuestionId.nodes;
    }
    if (value.essayRepliesByQuestionId) {
      essayRepliesByQuestionId = value.essayRepliesByQuestionId.nodes;
    }
    if (value.examQuestionsByQuestionId) {
      examQuestionsByQuestionId = value.examQuestionsByQuestionId.nodes;
    }
    if (value.assertionsByQuestionId) {
      assertionsByQuestionId = value.assertionsByQuestionId.nodes;
    }
    if (value.questionApplicationsByQuestionId) {
      questionApplicationsByQuestionId = value.questionApplicationsByQuestionId.nodes;
    }
    return {
      ...value,
      contentsByQuestionId,
      questionApplicationsByQuestionId,
      solutionsByQuestionId,
      materialsByQuestionId,
      essayRepliesByQuestionId,
      examQuestionsByQuestionId,
      assertionsByQuestionId
    };
  }
});

export const solution = new schema.Entity("solutions", {} , {
  processStrategy: (value: any, parent: any, key: string) => {
    let contentsBySolutionId;
    if (value.contentsBySolutionId) {
      contentsBySolutionId = value.contentsBySolutionId.nodes;
    }
    return {
      ...value,
      contentsBySolutionId
    }
  }
});

annotation.define({
  contentsByAnnotationId: [content]
});

article.define({
  contentsByArticleId: [content]
});

assertion.define({
  userByUserId: user,
  contentsByAssertionId: [content]
});

assignment.define({
  userByUserId: user,
  examByExamId: exam
});

board.define({
  materialsByBoardId: [material],
  boardSectionsByBoardId: [boardSection]
});

boardSection.define({
  materialsByBoardSectionsId: [material]
});

content.define({
  textByTextId: text,
  videoByVideoId: video,
  imageByImageId: image
});

correction.define({
  correctionScoresByCorrectionId: [correctionScore],
  essayReplyByEssayReplyId: essayReply
});

correctionCriteria.define({
  ltreeKnowledgeByKnowledgeId: knowledge
});

correctionScore.define({
  annotationsByCorrectionScoreId: [annotation],
  ltreeKnowledgeByKnowledgeId: knowledge,
  correctionCriteriaByCorrectionCriteriaId: correctionCriteria
});

essayReply.define({
  contentsByEssayReplyId: [content],
  correctionsByEssayReplyId: [correction],
  questionByQuestionId: question
});

examMode.define({
  questionsByExamModeId: [question]
});

examApplication.define({
  institutionByInstitutionId: institution,
  examinationBoardByExaminationBoardId: examinationBoard
});

examGroup.define({
  examGroupsExamsByExamGroupId: [examGroupsExams],
  materialsByExamGroupId: [material]
});

examGroupsExams.define({
  examGroupByExamGroupId: [examGroup]
});

examQuestion.define({
  examByExamId: exam
});

knowledge.define({
  ltreeKnowledgeAssociationsByLtreeKnowledgeId: [knowledgeAssociation],
  ltreeKnowledgeByParentId: knowledge,
  ltreeKnowledgesByParentId: [knowledge]
});

knowledgeAssociation.define({
  questionByQuestionId: question,
  articleByArticleId: article
})

listItem.define({
  questionByQuestionId: question,
  articleByArticleId: article,
  videoByVideoId: video
});

list.define({
  listItemsByListId: [listItem]
});

listItem.define({
  listByListId: list
});

material.define({
  boardByBoardId: board,
  boardSectionByBoardSectionsId: boardSection,
  questionByQuestionId: question
});

question.define({
  userByUserId: user,
  examApplicationByExamApplicationId: examApplication,
  examModeByExamModeId: examMode,
  contentsByQuestionId: [content],
  solutionsByQuestionId: [solution],
  materialsByQuestionId: [material],
  essayRepliesByQuestionId: [essayReply],
  examQuestionsByQuestionId: [examQuestion],
  assertionsByQuestionId: [assertion],
  questionApplicationsByQuestionId: [questionApplication]
})

questionApplication.define({
  questionByQuestionId: question,
  examApplicationByExamApplicationId: examApplication
})

solution.define({
  userByUserId: user,
  contentsBySolutionId: [content]
});